package org.hs_soft.runmynesto.domain.usecase.options.export

import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.pms_config.apaleo_properties.ApaleoPropertieModel
import org.hs_soft.runmynesto.domain.model.home.options.export.apaleo_sub_account.ApaleoSubAccountModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.export.ApaleoSubAccountRepository

class ApaleoSubAccountsUseCase(
    private val repository: ApaleoSubAccountRepository
) {
    suspend operator fun invoke(propertyId: String): ApaleoSubAccountModel {
        return repository.apaleoSubAccounts(propertyId)
    }
} 